import {useCallback} from 'react';

import {accessGroupEnum} from '../../../serverClientShared/sharedEnums';

const useAccessInfo = (accessMap, nodeInfoMap) => {
    const collectAncestorAccess = useCallback((nodeId) => {
        let isDirect = false;
        let inheritedIncludeAll = false;
        const inheritedFrom = [];
        let current = nodeInfoMap.get(nodeId)?.parentId;
        let depth = 0;
        while (current && depth < 50) {
            depth++;
            const parentInfo = accessMap[current];
            if (parentInfo?.isDirectIncludeAll) isDirect = true;
            if (parentInfo?.inheritedIncludeAll) {
                inheritedIncludeAll = true;
                for (const source of parentInfo.inheritedFrom || []) {
                    if (source.sourceId === accessGroupEnum.WORKSPACE_PUBLIC) continue;
                    if (!inheritedFrom.some(s => s.sourceId === source.sourceId)) {
                        inheritedFrom.push(source);
                    }
                }
            }
            current = nodeInfoMap.get(current)?.parentId;
        }
        return {isDirect, inheritedIncludeAll, inheritedFrom};
    }, [accessMap, nodeInfoMap]);

    const getAccessInfo = useCallback((nodeId) => {
        const direct = accessMap[nodeId];
        const ancestor = collectAncestorAccess(nodeId);
        const isDirect = direct?.isDirect || ancestor.isDirect;
        const inheritedIncludeAll = direct?.inheritedIncludeAll || ancestor.inheritedIncludeAll;
        const inheritedFrom = [...(direct?.inheritedFrom || []), ...ancestor.inheritedFrom];
        if (!isDirect && inheritedFrom.length === 0) return null;
        return {...direct, isDirect, inheritedIncludeAll, inheritedFrom};
    }, [accessMap, collectAncestorAccess]);

    return {getAccessInfo};
};

export default useAccessInfo;
